import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Dialer = ({ digit, sec_line, className, telephonySendDigits, }) => {
    return (_jsxs("button", Object.assign({ className: className, onClick: () => {
            telephonySendDigits(digit);
        } }, { children: [_jsx("span", Object.assign({ className: "digit" }, { children: digit })), _jsx("span", Object.assign({ className: "sec_line" }, { children: sec_line }))] })));
};
export default Dialer;
